import { Link, useLocation, Outlet } from 'react-router-dom';
import { 
  Home, 
  Search, 
  ScanSearch, 
  Network, 
  Upload, 
  Settings as SettingsIcon,
  Shield,
  Activity,
  Code
} from 'lucide-react';

export function Layout() {
  const location = useLocation();

  const navItems = [
    { path: '/', icon: Home, label: 'Dashboard' },
    { path: '/scanner', icon: ScanSearch, label: 'Scanner' },
    { path: '/lookup', icon: Search, label: 'Address Lookup' },
    { path: '/graph', icon: Network, label: 'Graph View' },
    { path: '/pools', icon: Activity, label: 'Pool Analysis' },
    { path: '/import-export', icon: Upload, label: 'Import/Export' },
    { path: '/api-docs', icon: Code, label: 'API Docs' },
    { path: '/settings', icon: SettingsIcon, label: 'Settings' },
  ];

  return (
    <div className="flex min-h-screen bg-gray-900">
      {/* Sidebar */}
      <aside className="w-64 bg-gray-800/50 border-r border-gray-700 backdrop-blur-sm flex flex-col">
        {/* Logo/Header */}
        <div className="p-6 border-b border-gray-700">
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 rounded-lg bg-gradient-to-br from-blue-500 to-purple-600">
              <Shield size={24} className="text-white" />
            </div>
            <div>
              <h1 className="text-xl font-bold bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
                VERSE Monitor
              </h1>
              <p className="text-xs text-gray-400">
                Abuse Detection
              </p>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 space-y-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;

            return (
              <Link
                key={item.path}
                to={item.path}
                className={`
                  flex items-center gap-3 px-4 py-3 rounded-lg
                  transition-all duration-200 group
                  ${isActive 
                    ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-lg shadow-blue-500/20' 
                    : 'text-gray-300 hover:bg-gray-700/50 hover:text-white'
                  }
                `}
              >
                <Icon size={20} className={isActive ? 'text-white' : 'text-gray-400 group-hover:text-blue-400'} />
                <span className="font-medium">{item.label}</span>
              </Link>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="p-4 border-t border-gray-700">
          <div className="p-3 rounded-lg bg-gray-700/30 border border-gray-600">
            <div className="flex items-center gap-2 mb-1">
              <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
              <span className="text-sm font-medium text-green-400">System Online</span>
            </div>
            <p className="text-xs text-gray-400">
              Monitoring Polygon Network
            </p>
          </div>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto bg-gradient-to-br from-gray-900 via-gray-900 to-gray-800">
        <div className="p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default Layout;
